import React from 'react';
import PropTypes from 'prop-types';
import useResourceSummary from './useResourceSummary';
import ItemCard from './ItemCard';
import ActionGroup from './ActionGroup';


export default function ResourceSummaryCard({
  resource,
  onClick,
  onActionClick,
  loading,
  test,
}) {
  const {
    title,
    subtitle,
    statusText,
    image,
    actions,
    mainAction,
    status,
  } = useResourceSummary(resource);

  const isOnClickAllowed = !!(onClick && mainAction);
  const isActionOnClickAllowed = !!onActionClick;

  const handleOnClick = () => onClick({ resource, action: mainAction });
  const handleOnActionClick = ({ action }) => onActionClick({ resource, action });

  return (
    <ItemCard
      test={test}
      title={title}
      subtitle={subtitle}
      imageURL={image}
      loading={loading}
      status={status}
      statusText={statusText}
      actionGroup={isActionOnClickAllowed && <ActionGroup actions={actions} onActionClick={handleOnActionClick} />}
      onClick={isOnClickAllowed ? handleOnClick : null}
    />
  );
}
ResourceSummaryCard.defaultProps = {
  onClick: undefined,
  onActionClick: undefined,
  loading: false,
  test: '',
};
ResourceSummaryCard.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onActionClick: PropTypes.func,
  loading: PropTypes.bool,
  test: PropTypes.string,
};
